import { Validator } from 'vee-validate'

// Import the `getField` getter and the `updateField`
// mutation function from the `vuex-map-fields` module.
import { updateField } from 'vuex-map-fields'

const messages = {}

const dictionary = {
  pt_BR: {
    messages: messages
  }
}

const has = (object) => {
  return typeof object !== 'undefined' && object !== null
}

const callback = (accumulator, current) => {
  if (has(current.data) && has(current.data.defaultValue)) {
    accumulator[current.key] = current.data.defaultValue
  }
  if (current.components) {
    current.components.reduce(callback, accumulator)
  }
  return accumulator
}

const mutations = {
  // Add the `updateField` mutation to the
  // `mutations` of your Vuex store instance.
  updateField,
  SET_CONFIG (state, payload) {
    state.config = payload
  },
  SET_JSON_INJETADO (state, payload) {
    state.config.json = payload
  },
  GET_FORM_REQUEST (state) {
    state.formJson = {}
  },
  GET_FORM_RECEIVE (state, payload) {
    if (payload.components.length) {
      payload.components.reduce(callback, {})
    }

    // SET messages validations
    Object.keys(payload.errorMessages).forEach(key => {
      messages[key] = (e, n) => (payload.errorMessages[key]).replace('{a}', n)
    })

    Validator.localize(dictionary)

    state.formJson = payload
    state.loading = false
  },
  GET_FORM_VERSION_REQUEST (state) {
    state.formJson = {}
  },
  SET_SHOW_ONLY (state, payload) {
    state.showOnly = payload
  },
  GET_FORM_VERSION_RECEIVE (state, payload) {
    if (payload.components.length) {
      payload.components.reduce(callback, {})
    }

    // SET messages validations
    Object.keys(payload.errorMessages).forEach(key => {
      messages[key] = (e, n) => (payload.errorMessages[key]).replace('{a}', n)
    })

    Validator.localize(dictionary)

    state.formJson = payload
    state.loading = false
  },
  GET_FORM_DATA_ID_REQUEST (state) {
    state.formDataId = {}
  },
  GET_FORM_DATA_ID_RECEIVE (state, payload) {
    state.formDataId = payload
  },
  FAILURE (state, payload) {
    state.failure = payload
    state.isFail = true
    state.loading = false
  },
  setLoadEvents (state, payload) {
    state.loadEvents = payload
  }
}

export default mutations
